(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    /* Header menu policy: phones + tablet portrait = drawer; landscape = menu. */
(() => {
  if (window.garzaTabletMenuInstalled) return;
  window.garzaTabletMenuInstalled = true;
  const portrait = window.matchMedia('(min-width: 750px) and (max-width: 1180px) and (orientation: portrait)');
  const landscape = window.matchMedia('(min-width: 870px) and (max-width: 1440px) and (orientation: landscape) and (pointer: coarse)');
  const phone = window.matchMedia('(max-width: 869px)');
  const compactDesktop = window.matchMedia('(min-width: 870px) and (max-width: 1000px) and (orientation: landscape)');
  let header, observer, lastMode, firstTapLink = null;
  function closeMenus() {
    header?.querySelectorAll('header-drawer').forEach(drawer => {
      if (drawer.isOpen && typeof drawer.close === 'function') drawer.close();
    });
    header?.querySelectorAll('header-menu').forEach(menu => {
      if (typeof menu.deactivate === 'function') menu.deactivate({target: document.body});
    });
    firstTapLink = null;
  }
  function apply() {
    if (!header?.isConnected) return;
    const mode = phone.matches || portrait.matches ? 'drawer' : (landscape.matches || compactDesktop.matches) ? 'menu' : null;
    if (mode !== lastMode) {
      closeMenus();
      if (mode) header.dataset.garzaTabletMode = mode;
      else delete header.dataset.garzaTabletMode;
      header.querySelectorAll('header-menu').forEach(menu => {
        if (mode === 'drawer') {
          menu.inert = true;
          menu.querySelectorAll('[aria-expanded="true"]').forEach(link => link.setAttribute('aria-expanded', 'false'));
          menu.querySelectorAll('[data-active]').forEach(panel => panel.removeAttribute('data-active'));
          menu.style.setProperty('--submenu-opacity', '0');
          header.style.setProperty('--submenu-height', '0px');
          header.style.setProperty('--full-open-header-height', '0px');
        } else {
          menu.inert = false;
          if (lastMode === 'drawer') menu.style.removeProperty('--submenu-opacity');
        }
      });
      // Restore native menu selection when leaving the tablet range.
      if (!mode && lastMode) {
        const touch = 'ontouchstart' in window && navigator.maxTouchPoints > 0;
        const overflow = header.querySelector('overflow-list[minimum-reached]');
        header.dataset.menuStyle = touch || overflow ? 'drawer' : 'menu';
      }
      lastMode = mode;
    }
    if (mode && header.dataset.menuStyle !== mode) header.dataset.menuStyle = mode;
  }
  function install() {
    const next = document.querySelector('#header-component');
    if (next === header) { apply(); return; }
    observer?.disconnect();
    header = next;
    lastMode = undefined;
    if (!header) return;
    observer = new MutationObserver(apply);
    observer.observe(header, {attributes: true, attributeFilter: ['data-menu-style']});
    apply();
  }
  [portrait, landscape, phone, compactDesktop].forEach(query => query.addEventListener('change', apply));
  document.addEventListener('shopify:section:load', install);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install, {once: true});
  else install();
  // Touch landscape: first tap opens the submenu, second tap follows the link.
  document.addEventListener('click', event => {
    if (!landscape.matches || !header) return;
    const target = event.target instanceof Element ? event.target : null;
    const link = target?.closest('header-menu .menu-list__link[aria-haspopup="true"]');
    if (link && header.contains(link)) {
      if (firstTapLink === link && link.getAttribute('aria-expanded') === 'true') {
        firstTapLink = null;
        return;
      }
      event.preventDefault();
      firstTapLink = link;
      const menu = link.closest('header-menu');
      const item = link.closest('.menu-list__list-item');
      if (menu && item && typeof menu.activate === 'function') menu.activate({target: item});
    } else if (!target?.closest('header-menu')) {
      closeMenus();
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && header?.dataset.garzaTabletMode === 'menu') closeMenus();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["carousel-img"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('image-carousel-block')) {
    class ImageCarouselBlock extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.image-carousel-block__track');
        this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
        this.currentIndex = 0;
        this.timer = null;
        this.autoplayEnabled = this.dataset.autoplay === 'true';
        this.interval = Math.max(Number(this.dataset.interval) || 5000, 1000);
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.track || this.slides.length < 2) return;

        this.handleDotClick = this.handleDotClick.bind(this);
        this.pause = this.pause.bind(this);
        this.play = this.play.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);

        this.dots.forEach((dot) => dot.addEventListener('click', this.handleDotClick));
        this.addEventListener('mouseenter', this.pause);
        this.addEventListener('mouseleave', this.play);
        this.addEventListener('focusin', this.pause);
        this.addEventListener('focusout', this.play);
        document.addEventListener('visibilitychange', this.handleVisibilityChange);

        this.showSlide(0);
        this.play();
      }

      disconnectedCallback() {
        this.pause();
        this.dots?.forEach((dot) => dot.removeEventListener('click', this.handleDotClick));
        this.removeEventListener('mouseenter', this.pause);
        this.removeEventListener('mouseleave', this.play);
        this.removeEventListener('focusin', this.pause);
        this.removeEventListener('focusout', this.play);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      }

      handleDotClick(event) {
        const nextIndex = Number(event.currentTarget.dataset.slideIndex);
        this.showSlide(nextIndex);
        this.restart();
      }

      handleVisibilityChange() {
        if (document.hidden) {
          this.pause();
        } else {
          this.play();
        }
      }

      showSlide(index) {
        const normalizedIndex = (index + this.slides.length) % this.slides.length;
        this.currentIndex = normalizedIndex;
        this.track.style.transform = `translate3d(-${normalizedIndex * 100}%, 0, 0)`;

        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === normalizedIndex ? 'false' : 'true');
        });

        this.dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === normalizedIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      next() {
        this.showSlide(this.currentIndex + 1);
      }

      play() {
        if (!this.autoplayEnabled || this.reduceMotion || document.hidden || this.slides.length < 2) return;
        this.pause();
        this.timer = window.setInterval(() => this.next(), this.interval);
      }

      pause() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      restart() {
        this.pause();
        this.play();
      }
    }

    customElements.define('image-carousel-block', ImageCarouselBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["panorama-2d"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('panorama-viewer')) {
    class PanoramaViewer extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-panorama-viewport]');
        this.image = this.querySelector('.panorama-2d__image');
        this.dragging = false;
        this.pointerId = null;
        this.startX = 0;
        this.startScrollLeft = 0;
        this.lastX = 0;
        this.lastTime = 0;
        this.velocity = 0;
        this.animationFrame = null;
        this.resizeFrame = null;
        this.positionInitialized = false;

        if (!this.viewport) return;

        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleResize = this.handleResize.bind(this);
        this.initializePosition = this.initializePosition.bind(this);

        this.viewport.addEventListener('pointerdown', this.handlePointerDown);
        this.viewport.addEventListener('pointermove', this.handlePointerMove);
        this.viewport.addEventListener('pointerup', this.handlePointerUp);
        this.viewport.addEventListener('pointercancel', this.handlePointerUp);
        this.viewport.addEventListener('keydown', this.handleKeyDown);
        this.viewport.addEventListener('touchstart', () => this.markAsInteracted(), { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });

        if (this.image && !this.image.complete) {
          this.image.addEventListener('load', this.initializePosition, { once: true });
        } else {
          this.initializePosition();
        }
      }

      disconnectedCallback() {
        if (!this.viewport) return;

        this.viewport.removeEventListener('pointerdown', this.handlePointerDown);
        this.viewport.removeEventListener('pointermove', this.handlePointerMove);
        this.viewport.removeEventListener('pointerup', this.handlePointerUp);
        this.viewport.removeEventListener('pointercancel', this.handlePointerUp);
        this.viewport.removeEventListener('keydown', this.handleKeyDown);
        window.removeEventListener('resize', this.handleResize);
        window.cancelAnimationFrame(this.animationFrame);
        window.cancelAnimationFrame(this.resizeFrame);
      }

      initializePosition() {
        window.requestAnimationFrame(() => {
          const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          const startPercentage = Math.min(100, Math.max(0, Number(this.dataset.startPosition) || 0));
          this.viewport.scrollLeft = maximumScroll * (startPercentage / 100);
          this.positionInitialized = true;
        });
      }

      handlePointerDown(event) {
        if (event.pointerType === 'touch' || event.button !== 0) return;

        window.cancelAnimationFrame(this.animationFrame);
        this.dragging = true;
        this.pointerId = event.pointerId;
        this.startX = event.clientX;
        this.startScrollLeft = this.viewport.scrollLeft;
        this.lastX = event.clientX;
        this.lastTime = performance.now();
        this.velocity = 0;
        this.viewport.classList.add('is-dragging');
        this.viewport.setPointerCapture(event.pointerId);
        this.markAsInteracted();
        event.preventDefault();
      }

      handlePointerMove(event) {
        if (!this.dragging || event.pointerId !== this.pointerId) return;

        const currentTime = performance.now();
        const elapsed = Math.max(1, currentTime - this.lastTime);
        const movement = event.clientX - this.startX;
        const frameMovement = event.clientX - this.lastX;

        this.viewport.scrollLeft = this.startScrollLeft - movement;
        this.velocity = -frameMovement / elapsed;
        this.lastX = event.clientX;
        this.lastTime = currentTime;
        event.preventDefault();
      }

      handlePointerUp(event) {
        if (!this.dragging || event.pointerId !== this.pointerId) return;

        this.dragging = false;
        this.viewport.classList.remove('is-dragging');

        if (this.viewport.hasPointerCapture(event.pointerId)) {
          this.viewport.releasePointerCapture(event.pointerId);
        }

        this.pointerId = null;

        if (this.dataset.inertia === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.startInertia();
        }
      }

      startInertia() {
        let previousTime = performance.now();

        const animate = (currentTime) => {
          const elapsed = Math.min(32, currentTime - previousTime);
          previousTime = currentTime;
          this.viewport.scrollLeft += this.velocity * elapsed;
          this.velocity *= Math.pow(0.94, elapsed / 16);

          const maximumScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
          const reachedStart = this.viewport.scrollLeft <= 0 && this.velocity < 0;
          const reachedEnd = this.viewport.scrollLeft >= maximumScroll && this.velocity > 0;

          if (Math.abs(this.velocity) > 0.02 && !reachedStart && !reachedEnd) {
            this.animationFrame = window.requestAnimationFrame(animate);
          }
        };

        this.animationFrame = window.requestAnimationFrame(animate);
      }

      handleKeyDown(event) {
        const step = Math.max(80, this.viewport.clientWidth * 0.12);

        if (event.key === 'ArrowLeft') {
          this.viewport.scrollBy({ left: -step, behavior: 'smooth' });
          this.markAsInteracted();
          event.preventDefault();
        }

        if (event.key === 'ArrowRight') {
          this.viewport.scrollBy({ left: step, behavior: 'smooth' });
          this.markAsInteracted();
          event.preventDefault();
        }

        if (event.key === 'Home') {
          this.viewport.scrollTo({ left: 0, behavior: 'smooth' });
          this.markAsInteracted();
          event.preventDefault();
        }

        if (event.key === 'End') {
          this.viewport.scrollTo({ left: this.viewport.scrollWidth, behavior: 'smooth' });
          this.markAsInteracted();
          event.preventDefault();
        }
      }

      handleResize() {
        window.cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = window.requestAnimationFrame(() => {
          if (!this.positionInitialized) {
            this.initializePosition();
            return;
          }

          const maximumScroll = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
          this.viewport.scrollLeft = Math.min(this.viewport.scrollLeft, maximumScroll);
        });
      }

      markAsInteracted() {
        this.classList.add('has-interacted');
      }
    }

    customElements.define('panorama-viewer', PanoramaViewer);
  }
  } catch(e) { console.error(e); }
})();

})();
